import { MaterialBlance, deleteMaterialBalances, getMaterialBalance } from "@/services/project/material-balance.service"
import classNames from "classnames"
import styles from './styles.module.less'
import { AddMaterialBalanceModal } from "./AddMaterialBalanceModal"
import { MoreOutlined, PlusOutlined } from "@ant-design/icons"
import { Dropdown } from "antd"
import { useNavigate } from "react-router"
import { ConfigMaterialBalanceModal } from "./ConfigMaterialBalanceModal"
import { OPermission } from "@/components/OPermission/OPermission"
import { ROLE_CHEMENG } from "@/components/OPermission/PlanPermission"

interface MaterialBalanceCardProps {
  balance: MaterialBlance
  pId: string
  reload: () => void
}

export const MaterialBalanceCard = (props: MaterialBalanceCardProps) => {
  const {balance, reload, pId} = props;
  const navigate = useNavigate()

  const items = [
    {
      key: 'config',
      label: 'Configure',
    },
    {
      key: 'view',
      label: 'View',
    },
    {
      key: 'delete',
      danger: true,
      label: 'Delete',
    },
  ]

  const onItemClick = async ({key}) => {
    switch (key) {
      case 'delete': {
        await deleteMaterialBalances(balance.id)
        reload()
        return;
      }
      case 'config': {
        const fullData = await getMaterialBalance(balance.id)
        ConfigMaterialBalanceModal.show({
          pId,
          balance: fullData,
          onSuccess: () => {
            reload()
          }
        })
        return
      }
      default:
        break;
    }
  }

  const gotoItem = () => {
    navigate(`/main/projects/${pId}/mb/${balance.id}`)
  }

  return <div className={classNames(styles.cardContainer, 'ml-2')} onClick={gotoItem}>
    <OPermission permissions={ROLE_CHEMENG}>
      <div className={styles.cardActions} onClick={(e) => e.stopPropagation()}>
        <Dropdown menu={{ items, onClick: onItemClick }}>
          <MoreOutlined style={{fontSize: 24}} />
        </Dropdown>
      </div>
    </OPermission>
    <div className={styles.cardName}>{balance.name}</div>
    <div className={styles.cardDescription}>{balance.description}</div>
  </div>
}

interface CreateMaterialBalanceCardProps {
  pId: string
  reload: () => void
}

export const CreateMaterialBalanceCard = (props: CreateMaterialBalanceCardProps) => {
  const {pId, reload} = props;

  return <div className={classNames(styles.cardContainer, 'ml-2', 'flex-col-center')}>
    <div style={{width: '100%', cursor: 'pointer'}} onClick={() => AddMaterialBalanceModal.show({pId, onSuccess: () => {
      reload()
    }})}>
      <div style={{textAlign: 'center', fontSize: 24, color: '#2C60EA'}}><PlusOutlined /></div>
      <div style={{textAlign: 'center', fontSize: 24, color: '#2C60EA'}} className="mt-1">New Material Balance</div>
    </div>
  </div>
}